import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { ApiErrorFactory } from '../../../core/api-errors';
import { SiteService } from '../../../core/site';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-domain.component.html',
  styleUrls: [`./delete-domain.styles.scss`],
  standalone: false,
})
export class DeleteDomainDialogComponent {
  public siteId: string;
  public domain: string;
  public disableInput = false;

  constructor(
    public dialogRef: MatDialogRef<DeleteDomainDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private alertService: SnackbarService,
    private apiErrorFactory: ApiErrorFactory,
    private translateService: TranslateService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.siteId = data.siteId;
    this.domain = data.domain;
  }

  onOKClick(): void {
    this.disableInput = true;
    this.analyticsService.trackEvent('domain:delete-domain', 'delete-domain', 'click');
    this.siteService.deleteDomainV2(this.siteId, this.domain).subscribe(
      () => {
        this.handleSuccess();
      },
      (err) => {
        this.handleError(err);
      },
    );
  }

  onCancelClick(): void {
    this.disableInput = true;
    this.dialogRef.close(false);
  }

  private handleSuccess(): void {
    this.dialogRef.close(true);
  }

  private handleError(errorResponse: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactory.parseErrorResponse(errorResponse);
    this.alertService.openErrorSnack(
      parsedError.getUserMessage(),
      this.translateService.instant('ALERTS.GENERAL.DISMISS'),
    );
    this.dialogRef.close(false);
  }
}
